var React = require('react');

function SocialsFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.0039 15C30.0039 6.71371 23.2902 0 15.0039 0C6.71762 0 0.00390625 6.71371 0.00390625 15C0.00390625 22.5 5.44745 28.7298 12.645 29.8185V19.3548H8.83455V15H12.645V11.7339C12.645 7.98387 14.8829 5.86694 18.27 5.86694C19.9636 5.86694 21.6571 6.16935 21.6571 6.16935V9.85887H19.7821C17.9071 9.85887 17.3023 11.0081 17.3023 12.2177V15H21.4757L20.8104 19.3548H17.3023V29.8185C24.4999 28.7298 30.0039 22.5 30.0039 15Z","fill":"#D16AA9"}));
}

SocialsFacebook.defaultProps = {"width":"31","height":"30","viewBox":"0 0 31 30","fill":"none"};

module.exports = SocialsFacebook;

SocialsFacebook.default = SocialsFacebook;
